import React, { useState } from "react";
import { Card } from "react-bootstrap";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import TableProductsTable from "components/Tables/TableProductsTable";

export default function RestaurantTable({ tableId, tableName, tableColor, className, isOpened, total, onClick }) {
  const [isHovered, setIsHovered] = useState(false);
  const style = { width: "7rem", margin: "0.3rem", transition: "transform 0.3s ease-in-out" };
  const hoverStyle = { transform: "translateY(-7px)", cursor: "pointer" };

  const table = (
    <Card
      style={{ ...style, ...(isHovered ? hoverStyle : {}) }}
      className={isOpened ? "shadow-sm border-0" : className}
      onMouseEnter={() => {
        if (isOpened) setIsHovered(true);
      }}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      <Card.Header className="p-1">
        <Card.Title as="h5" className="text-center">
          {tableName}
        </Card.Title>
      </Card.Header>
      <Card.Body style={{ height: "1rem" }}></Card.Body>
      <Card.Footer
        as="h6"
        className={total ? "p-0 text-center" : "p-3"}
        style={{ backgroundColor: isOpened ? "#bd40ba" : tableColor, color: "white" }}
      >
        {total}
      </Card.Footer>
    </Card>
  );

  return (
    <>
      {isOpened ? (
        <Popup
          arrow={false}
          contentStyle={{ width: "50vw" }}
          trigger={table}
          position={["center center", "right center"]}
        >
          <TableProductsTable tableId={tableId} tableName={tableName} />
        </Popup>
      ) : (
        table
      )}
    </>
  );
}
